<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>
<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>

<head>
  <link rel="stylesheet" href="profile-page.component.css">z
</head>

<div *ngIf="!loading && currUser && currCompany">

  <body class="green lighten-5">
    <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
      <app-navbar></app-navbar>
    </div>

    <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
      <br>
      <br>
      <br>
      <br>

      <!-- <div class="blue-grey lighten-5"> -->
      <div class="white profile-container">
        <div class="row">
          <h2 class="heading">Welcome, {{currUser?.strName}}</h2>
        </div>
        <div class="row profile-section">
          <div class="col s3">
            <img src="assets/gray-photo-placeholder-icon-design-ui-vector-35850819.jpg" class="profile-photo">
          </div>
          <div class="col s9 details-list">
            <span>
              <h5 style="color: rgb(103, 169, 255); display: inline;"> {{currUser?.role}} </h5>
              <h4 *ngIf="currUser?.role == 'Vendor'" style="display: inline; color: grey;"> | </h4>
              <p *ngIf="currUser?.role == 'Vendor'" style="display: inline; color: grey;">
                {{currUser?.strAccountStatus}} </p>
            </span>
            <br>
            <h5>
              <b>Company: </b> {{currCompany?.strCompanyName}}
            </h5>
            <h5>
              <b>Position: </b> {{currUser?.strJobTitle}}
            </h5>
            <h6 *ngIf="currUser?.role == 'Vendor' && currUser?.strAccountStatus == 'Approved'">
              <b>Approved Since: </b> {{currUser?.strAccountStatusDate}}
            </h6>

          </div>
        </div>
        <div *ngIf="currUser?.role == 'Vendor'" class="row profile-section">
          <div class="col s6 profile-col">
            <h4>Your Documents</h4>
            <br>

            <div class="documents-grid">
              <ng-container *ngFor="let doc of documentList">
                <div *ngIf="doc.data && doc.path" class="document-item">
                  <p class="doc-label">{{ doc.label }}</p>
                  <a [href]="'data:application/pdf;base64,' + doc.data" [download]="doc.path" target="_blank"
                    rel="noopener noreferrer" class="doc-link">
                    {{ doc.path }}
                  </a>
                  <p *ngIf="doc.expiry" class="doc-expiry">Expiry: {{ doc.expiry | date:'longDate' }}</p>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col s6">
            <h4>More About You</h4>
            <br>

            <div class="documents-grid1">
              <!-- Type of Organization -->
              <span class="document-item">
                <h5>Type of Organization: </h5> {{ orgType }}
              </span>

              <!-- Type of Business -->
              <div class="document-item">
                <h5>Type of Business: </h5>
                <ul style="display: inline-block;" class="type-list">
                  <li class="type-item" *ngFor="let type of businessTypeLabels; let i = index">
                  <span>{{ type }}</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </body>
</div>